import EditBook from "../edit/EditBook";

export default function Edit() {
    return (
        <main className="py-6 2xl:px-6">
            <div className="container">
                <EditBook />
            </div>
        </main>
    );
}
